import { ClientProfileEntity, ClientProfileUpdateEntity } from '@/entities/client-profile.entity';
import { EndpointOptions } from '@/types/endpoint.options';
import { getAxiosInstance, withSuppressedErrorToast } from '@/client/get-axios-instance';
import { buildMarketplaceApiPath } from '@/repositories/marketplace-api-paths';

class ClientProfileRepository {
    private readonly _axios = getAxiosInstance(buildMarketplaceApiPath('settings/client-profile'));

    put(data: ClientProfileUpdateEntity, options?: EndpointOptions) {
        return this._axios.put<ClientProfileEntity>('', data, {
            ...withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        });
    }
}

export const createClientProfileRepository = () => new ClientProfileRepository();

export const clientProfileRepository = createClientProfileRepository();
